import { render } from "./CookieConsentModal.vue?vue&type=template&id=421261d6&scoped=true&lang=pug"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"

import "./CookieConsentModal.vue?vue&type=style&index=0&id=421261d6&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421261d6"]])

export default __exports__